import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = [
  { label: 'S.N', value: 'id' },
  {
    label: 'Material Hub',
    value: 'locationName',
  },
  {
    label: 'Households',
    value: 'linkedCustomerName',
  },
  {
    label: 'FTS Facility',
    value: 'linkedPickupPointName',
  },
  {
    action: ['edit'],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }
